import { CategoryGeneratorState } from '@quizzach/interfaces';

export function syncSessionStorageWithApi(
	apiResponse: CategoryGeneratorState[],
	sessionStorageObject: CategoryGeneratorState[]
) {
	// Create a map of categories and subcategories from the API response for quick lookup
	const apiMap = new Map();

	apiResponse.forEach((category) => {
		const subcategoriesMap = new Map();
		category.subcategories.forEach((subcategory) => {
			subcategoriesMap.set(subcategory.id, subcategory);
		});

		apiMap.set(category.id, {
			...category,
			subcategories: subcategoriesMap,
		});
	});

	// Iterate over the session storage object
	for (let i = 0; i < sessionStorageObject.length; i++) {
		const localCategory = sessionStorageObject[i];
		const apiCategory = apiMap.get(localCategory.id);

		// If the category exists in the API response
		if (apiCategory) {
			// Update the category's available questions if not 0
			if (
				apiCategory.available_questions &&
				apiCategory.available_questions !== 0
			) {
				localCategory.available_questions = apiCategory.available_questions;
				localCategory.available_questions_1 = apiCategory.available_questions_1;
				localCategory.available_questions_2 = apiCategory.available_questions_2;
				localCategory.available_questions_3 = apiCategory.available_questions_3;
			} else {
				// Remove the category from session storage if available_questions is 0
				sessionStorageObject.splice(i, 1);
				i--;
				continue;
			}

			// Process the subcategories
			const apiSubcategories = apiCategory.subcategories;
			for (let j = 0; j < localCategory.subcategories.length; j++) {
				const localSubcategory = localCategory.subcategories[j];
				const apiSubcategory = apiSubcategories.get(localSubcategory.id);

				// If the subcategory exists in the API response
				if (apiSubcategory) {
					if (
						apiSubcategory.available_questions &&
						apiSubcategory.available_questions !== 0
					) {
						// Update the subcategory's available questions
						localSubcategory.available_questions =
							apiSubcategory.available_questions;
						localSubcategory.available_questions_1 =
							apiSubcategory.available_questions_1;
						localSubcategory.available_questions_2 =
							apiSubcategory.available_questions_2;
						localSubcategory.available_questions_3 =
							apiSubcategory.available_questions_3;
					} else {
						// Remove the subcategory if available_questions is 0
						localCategory.subcategories.splice(j, 1);
						j--;
					}
				} else {
					// Remove the subcategory if it does not exist in the API response
					localCategory.subcategories.splice(j, 1);
					j--;
				}
			}
		} else {
			// Remove the category if it does not exist in the API response
			sessionStorageObject.splice(i, 1);
			i--;
		}
	}

	// Return the updated session storage object
	return sessionStorageObject;
}
